import store from './../store'
import env from './../env'

export default {
  path: '/open-to-work',
  name: 'open-to-work',
  redirect: { name: 'open-to-work.profile-page' },
  component: () => import('@/views/openToWork/index.vue'),
  children: [
    {
      path: '/open-to-work',
      name: 'open-to-work.profile-page',
      component: () => import('@/views/openToWork/ProfilePage.vue'),
    },
    {
      path: '/open-to-work/requests',
      name: 'open-to-work.requests-page',
      component: () => import('@/views/openToWork/RequestsPage.vue'),
    },
    {
      path: '/open-to-work/jobs',
      name: 'open-to-work.jobs-page',
      component: () => import('@/views/openToWork/JobsPage.vue'),
    },
    {
      path: '/open-to-work/applications',
      name: 'open-to-work.applications-page',
      component: () => import('@/views/openToWork/ApplicationsPage.vue'),
    },
    {
      path: '/open-to-work/jobs/:jobId',
      name: 'open-to-work.job-page',
      component: () => import('@/views/openToWork/JobPage.vue'),
    },
  ],
  // Open to Work is a tradie's own "available for work" profile — a business
  // admin account has no such profile. Same beforeEnter shape as
  // candidates.js/tradies.js (which gate the opposite direction: BA-only).
  beforeEnter: async (to, from, next) => {
    if (!env.openToWorkEnabled) return next({ name: 'page-not-found' })
    if (store.state.auth.user) {
      if (store.state.auth.user.user_type !== 'tradie')
        return next({ name: 'page-not-found' })
      return next()
    }
    store
      .dispatch('auth/getAuthenticatedUser')
      .then(() => {
        if (store.state.auth.user.user_type !== 'tradie')
          next({ name: 'page-not-found' })
        else next()
      })
      .catch(() => next({ name: 'auth.login-page' }))
  },
}
